import dayjs from "dayjs";
import { useEffect, useState } from "react";
import utc from "dayjs/plugin/utc";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { Button } from "components/atoms";
import "./index.scss";

dayjs.extend(utc);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

interface IProps {
  data: any;
}

export const LaunchSessionButton = ({ data }: IProps) => {
  const [isLaunchBtnEnable, setIsLaunchBtnEnable] = useState(false);

  useEffect(() => {
    const fifteenMinsBeforeTime: any = dayjs
      .utc(data.NextSession.LaunchStartDateUtc)
      .local();

    const interval = setInterval(() => {
      if (
        dayjs().isSameOrAfter(fifteenMinsBeforeTime) &&
        dayjs().isSameOrBefore(dayjs.utc(data.NextSession.EndDateUtc).local())
      ) {
        setIsLaunchBtnEnable(true);
      } else {
        setIsLaunchBtnEnable(false);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [data.NextSession.LaunchStartDateUtc, data.NextSession.EndDateUtc]);

  return (
    <div className="btn-section">
      <Button
        icon={false}
        label="Launch"
        type="active"
        isDisabled={!isLaunchBtnEnable}
        styles="study-planner-custom-btn-styles"
        onClick={() => window.open(data.NextSession.LaunchUrl, "_blank")}
      />
    </div>
  );
};
